import { FC } from 'react';
import Box from '@mui/material/Box';
import DatePicker from 'app/components/DatePicker';
import ErrorText from 'app/components/ErrorText';
import { isMobile } from 'utils/isMobile';

interface Props {
  error?: string;
}

const DeliveryReturnDateFields: FC<Props> = ({ error }) => (
  <Box>
    <Box
      display="flex"
      flexDirection={isMobile ? 'column' : 'row'}
      alignItems={isMobile ? 'stretch' : 'flex-start'}
      gap={2}
    >
      <DatePicker type="delivery" surface="dark" />
      <DatePicker type="return" surface="dark" />
    </Box>
    {error && (
      <ErrorText align="center" textColor="primary.contrastText">
        {error}
      </ErrorText>
    )}
  </Box>
);

export default DeliveryReturnDateFields;
